import { render } from "./TestResults.vue?vue&type=template&id=7ec6ca65"
import script from "./TestResults.vue?vue&type=script&lang=js"
export * from "./TestResults.vue?vue&type=script&lang=js"

import "./TestResults.vue?vue&type=style&index=0&id=7ec6ca65&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__